// extracted by mini-css-extract-plugin
export var bounce = "_mr-1";
export var generatingText = "_mr-6";
export var lightning = "_mr-4";
export var popup = "_mr-5";
export var progressBar = "_mr-7";
export var progressFill = "_mr-8";
export var progressShimmer = "_mr-9";
export var progressText = "_mr-a";
export var shimmer = "_mr-3";
export var uploadIcon = "_mr-0";
export var uploadingText = "_mr-2";